<button
  type="button"
  class="group flex items-center gap-1.5 w-full py-0.5 bg-transparent border-0 cursor-pointer text-left text-xs text-gray-900"
  [attr.aria-expanded]="_expanded()"
  (click)="toggle()">
  <span
    class="material-symbols-outlined flex-shrink-0 text-sm text-gray-700 transition-transform"
    [class.animate-spin]="state() === 'pending'"
    [class.!text-blue-500]="state() === 'pending'"
    [class.!text-red-600]="state() === 'error'"
    [class.rotate-90]="
      _expanded() && state() !== 'pending' && state() !== 'error'
    ">
    {{ headerIcon() }}
  </span>
  <span class="font-medium group-hover:text-gray-1100">{{
    displayName()
  }}</span>
</button>
@if (_expanded()) {
  <div class="flex flex-col gap-2 pt-1 pb-2 pl-5">
    @if (formattedArgs()) {
      <div>
        <div
          class="font-semibold uppercase tracking-wider mb-0.5 text-[0.625rem] text-gray-700">
          ARGUMENTS
        </div>
        <pre
          class="m-0 overflow-auto whitespace-pre-wrap break-words rounded max-h-40 py-1.5 px-2 font-mono text-[0.6875rem] leading-normal bg-gray-100 border border-gray-300"
          >{{ formattedArgs() }}</pre
        >
      </div>
    }
    @if (formattedResult()) {
      <div>
        <div
          class="font-semibold uppercase tracking-wider mb-0.5 text-[0.625rem] text-gray-700">
          RESULT
        </div>
        <pre
          class="m-0 overflow-auto whitespace-pre-wrap break-words rounded max-h-40 py-1.5 px-2 font-mono text-[0.6875rem] leading-normal bg-gray-100 border border-gray-300"
          >{{ formattedResult() }}</pre
        >
      </div>
    }
  </div>
}
